export default __webpack_public_path__ + "static/11_27-f4df2820aff6ba80b15a2106473bb35a.png";